import { Variables } from '@enter/core';

export interface IOrdinalProps {
    ord: number;
}
export const ordinalColors = (props: IOrdinalProps): string => {
    switch (props.ord) {
        case 0:
            return Variables.Colors.sunset300;
        case 1:
            return Variables.Colors.b200;
        case 2:
            return Variables.Colors.b500;
        case 3:
            return Variables.Colors.g100;
        case 4:
        default:
            return '';
    }
};

export const pieChartColors = (props: IOrdinalProps): string => {
    switch (props.ord) {
        case 0:
            return Variables.Colors.b75;
        case 1:
            return Variables.Colors.b100;
        case 2:
            return Variables.Colors.sunset200;
        case 3:
            return Variables.Colors.sunset300;
        default:
            return '';
    }
};
